import * as React from 'react';
import { default as BaseModal } from '@mui/material/Modal';
import { ReactElement } from 'react';
import Box from '@mui/material/Box';

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 'fit-content',
    minWidth: 300,
    maxWidth: 1200,
    maxHeight: '90vh',
    overflow: 'auto',
    bgcolor: '#f5f5f5',
    border: '1px solid #000',
    boxShadow: 24,
    borderRadius: 1,
    p: 4,
};

interface ModalProps {
    isOpen: boolean;
    handleClose: () => void;
    children: ReactElement;
}

const Modal: React.FC<ModalProps> = ({
    handleClose,
    isOpen,
    children,
}) => {
    return (
        <BaseModal
            open={isOpen}
            onClose={handleClose}
        >
            <Box sx={style}>
                {children}
            </Box>
        </BaseModal>
    );
};

export default Modal;